export type WebhookModel = {
  active?: boolean,
  cache_key: number,
  enable_all_events?: boolean,
  enabled_events?: any,
  id: number,
  log_email?: string,
  owner_id: number,
  owner_type: string,
  secret_key?: string,
  title: string,
  url: string,
  webhook_version?: string,
}

const state = {
  active: true,
  enable_all_events: true,
  enabled_events: {},
  id: null,
  log_email: '',
  owner_id: undefined,
  owner_type: '',
  secret_key: '',
  title: '',
  url: '',
  webhook_version: 'V1',
}

export const requiredFields = [
  { key: 'title' },
  { key: 'url' },
]

export default state
